import Information16 from '@carbon/icons-react/es/information/16';
import { Space, Tooltip } from 'antd';
import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';
import { SingleLineEllipsis } from 'components/styles';

const InfoIcon = styled(Information16)`
  color: var(--gray-40);
`;

const IconWrapper = styled.span`
  display: flex;
`;

const Title = styled.span`
  ${SingleLineEllipsis};
  * {
    ${SingleLineEllipsis};
  }
`;

const Wrapper = styled.span<{ align: string }>`
  display: flex;
  align-items: center;
  justify-content: ${({ align }) =>
    align === 'right'
      ? 'flex-end'
      : align === 'center'
      ? 'center'
      : 'flex-start'};
  gap: 4px;

  ${IconWrapper} {
    flex-shrink: 0;
  }
  ${InfoIcon} {
    flex-shrink: 0;
  }
`;

interface Props {
  title: ReactNode;
  icon?: ReactNode;
  description?: ReactNode;
  align?: 'left' | 'right' | 'center';
  className?: string;
}
const TooltipForHeader: FC<Props> = ({ title, description }) => (
  <Space direction="vertical">
    <strong>{title}</strong>
    {description}
  </Space>
);

export const COLUMN_HEADER_WIDTH = 125;

export const ColumnHeader: FC<Props> = ({
  title,
  description,
  icon,
  align = 'left',
  className,
}) => (
  <Tooltip title={<TooltipForHeader title={title} description={description} />}>
    <Wrapper align={align} className={className}>
      {icon != null ? <IconWrapper>{icon}</IconWrapper> : null}
      <Title>{title}</Title>
      {description != null ? <InfoIcon /> : null}
    </Wrapper>
  </Tooltip>
);
